//sitemap
//=========
if (typeof $ === 'function') {

  function renderAgain() {
    $(window).trigger('resize');
    setTimeout(function () { $(window).trigger('resize'); }, 40);
    setTimeout(function () { $(window).trigger('resize'); }, 80);
    setTimeout(function () { $(window).trigger('resize'); }, 160);
    setTimeout(function () { $(window).trigger('resize'); }, 320);
  }

  //masonry
  //---------
  var html = $('html'),
      masonry = $('#siteMapPages'),
      tiles = masonry.find('.sitemap--branch').not('.no-masonry'),
      cols = 1,
      adjustNextTile = function (index, tile) {
        //console.log(cols)
        var thisTile = $(tile),
            thisList = thisTile.find('.sitemap--branch_list');
        //adjust first visible cols-th tile
        tiles.eq(index + cols).each(function () {
          var nextTile = $(this);
          if (nextTile.is(':visible')) {
            nextTile.css('margin-top', thisList.outerHeight() - thisTile.outerHeight());
            return false;
          }
        });
      };

  //do not initialize if no sitemap
  if (masonry.length) {

    $(window).on('resize', function () {

      //console.log('realign')

      //set columns number & reset
      cols = html.is('.media-xl') ? 3 : (html.is('.media-lg') || html.is('.media-md') ? 2 : 1);
      tiles.css('margin-top', '');

      //if there are any columns...
      if (cols < 2) return;

      //... adjust all tiles
      tiles.each(adjustNextTile);

    });

    //give the masonry layout some time to re-render
    renderAgain();

  }


  //search
  //--------
  var sitemap = $('#siteMapPages'),
      lists = sitemap.find('.sitemap--branch_list'),
      items = lists.find('li').not('.sitemap--branch_title'),
      caseMap = [
        '(a|á|ä)',
        '(c|č)',
        '(d|ď)',
        '(e|é|ě)',
        '(i|í)',
        '(n|ň)',
        '(o|ó|ö)',
        '(r|ř)',
        '(s|š)',
        '(t|ť)',
        '(u|ú|ů|ü)',
        '(y|ý)',
        '( | |&nbsp;)'
      ],
      lastVal = '';

  //do not initialize if no sitemap
  if (sitemap.length) {

    //initialize
    $('#sitemapSearch').on('change click mouseup keyup paste search', function () {
      var thisInput = $(this),
          val = thisInput.val(),
          regex;

      //event triggered but input value has not been changed, no nothing...
      if (lastVal === val) return;

      //else remember the last value
      lastVal = val;
      //console.log(val)

      //clear all...
      items.each(function () {
        var thisItem = $(this),
            thisItemLink = thisItem.find('a');
        thisItemLink.html(thisItemLink.text());
        thisItem.show();
      });
      lists.removeClass('sitemap--branch_list__hidden');

      //... and exit if value is empty
      if (!val) {
        //give the masonry layout some time to re-render
        renderAgain();
        return;
      }

      //prepare regex
      val = val.toLowerCase();
      $.each(caseMap, function (index, letter) {
        val = val.replace(new RegExp(letter, 'g'), letter);
      });
      regex = new RegExp('(' + val + ')', 'ig');

      //search for matches
      items.each(function () {
        var thisItem = $(this),
            thisItemLink = thisItem.find('a'),
            text = thisItemLink.text(),
            match = regex.test(text);

        //strip previous tags
        thisItemLink.html(text);
        //console.log(text)
        //console.log(regex)
        //console.log(match)

        if (match) {
          //console.log(regex)
          //console.log('show()')
          thisItemLink.html(text.replace(regex, '<span class="bg-sulphur">$1</span>'))
          thisItem.show();
        } else {
          //console.log('hide()')
          thisItem.hide();
        }
      });

      //hide lists if empty and vice versa
      lists.each(function () {
        var thisList = $(this);
        if (thisList.find('li').not('.sitemap--branch_title').filter(':visible').length) {
          thisList.removeClass('sitemap--branch_list__hidden');
        } else {
          thisList.addClass('sitemap--branch_list__hidden');
        }
      });

    //give the masonry layout some time to re-render
    renderAgain();

    }).trigger('change');

  }

}
